// extracted by mini-css-extract-plugin
export default {"VehiclesSection":"RecommendedVehicles_VehiclesSection__oxD15"};